import React, { useEffect, useState, useMemo, useRef, useContext } from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import Draggable from 'react-draggable';
import $ from 'jquery';
import 'datatables.net-bs5';
import { ThemeContext } from "../../Layout/Theme/ThemeContext";

function OutputParameters({
    outputData,
    outputParams = [],
    onClose,
    reportTitle = "Report",
    additionalInfo = "",
    inputValues = {},
    reportLink = ""
}) {
    const { theme } = useContext(ThemeContext);
    const tableRef = useRef();
    const [imageData, setImageData] = useState(null);

    // Dynamically generate columns if outputParams not provided
    const dynamicParams = useMemo(() => {
        if (outputParams.length > 0) return outputParams;
        if (outputData.length === 0) return [];

        return Object.keys(outputData[0]).map((key) => ({
            ColumnName: key,
            DisplayName: key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
        }));
    }, [outputParams, outputData]);

    // Initialize DataTable
    useEffect(() => {
        if (outputData && outputData.length > 0 && tableRef.current) {
            if ($.fn.DataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable().destroy();
            }
            $(tableRef.current).DataTable({
                dom: '<"row"<"col-sm-6 d-flex align-items-center"Bf><"col-sm-6 d-flex justify-content-end"p>>rt',
                pagingType: 'full_numbers',
                lengthChange: false,
                language: {
                    search: "_INPUT_",
                    searchPlaceholder: "Search..."
                },
                initComplete: function () {
                    $('.btn-dataTable').css('background', 'none').css('border', 'none')
                        .removeClass('btn btn-secondary btn-dataTable');
                }
            });

            $('#datatable-search-container').append($('.dataTables_filter').html());
            $('.dataTables_filter').remove();
        }
    }, [outputData]);

    // Load Logo
    useEffect(() => {
        const loadImage = async () => {
            const response = await fetch('assets/img/resources/trent.PNG');
            const blob = await response.blob();
            const reader = new FileReader();
            reader.onloadend = () => {
                setImageData(reader.result);
            };
            reader.readAsDataURL(blob);
        };
        loadImage();
    }, []);

    // PDF Generation
    const generatePDF = async () => {
        try {
            let url = reportLink;
            debugger;
            Object.keys(inputValues).forEach((key) => {
                const placeholder = new RegExp(`{${key}}`, 'g');
                let value = inputValues[key];
                if (key === "ClientID") {
                    value = localStorage.getItem("CompanyID");
                } else if (key === "UserID") {
                    value = localStorage.getItem("UserID");
                }
                url = url.replace(placeholder, value);
            });

            const queryParams = new URLSearchParams({
                ...inputValues,
                format: 'pdf'
            }).toString();

            url += (url.includes('?') ? '&' : '?') + queryParams;

            const response = await fetch(url);
            if (!response.ok) throw new Error('Failed to download PDF');

            const blob = await response.blob();
            const pdfURL = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = pdfURL;
            link.download = `${reportTitle}.pdf`;
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (err) {
            console.error('Error downloading PDF:', err);
            alert('Failed to download PDF.');
        }
    };

    const handleStart = (e, ui) => {
        e.stopPropagation();
    };

    return (
        <div className="modal fade show d-block" tabIndex="-1" aria-labelledby="outputModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-xl">
                <Draggable handle=".modal-content" onStart={handleStart}
                    cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Report Output</h5>
                            <button type="button" className="btn-close" onClick={onClose}></button>
                        </div>
                        <div className="modal-body">
                            {outputData.length === 0 ? (
                                <div className="text-center text-muted">No data available.</div>
                            ) : (
                                <div style={{ margin: "10px" }}>
                                    <table className="table table-striped table-bordered" ref={tableRef} style={{ width: "100%" }}>
                                        <thead>
                                            <tr>
                                                {dynamicParams.map(param => (
                                                    <th key={param.ColumnName}>{param.DisplayName}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {outputData.map((row, index) => (
                                                <tr key={index}>
                                                    {dynamicParams.map(param => {
                                                        const value = row[param.ColumnName] || "";
                                                        if (typeof value === 'string' && value.includes('T')) {
                                                            const date = new Date(value);
                                                            return <td key={param.ColumnName}>{isNaN(date) ? value : date.toISOString().split('T')[0]}</td>;
                                                        }
                                                        return <td key={param.ColumnName}>{value}</td>;
                                                    })}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-success" onClick={generatePDF}>Download PDF</button>
                             <button className="btn btn-danger" onClick={onClose}>
                                    <i className="icofont-close" aria-hidden="true"> Close</i>
                                </button>
                        </div>
                    </div>
                </Draggable>
            </div>
        </div>
    );
}

export default OutputParameters;
